import React from "react";
import AboutHero from "../components/About/hero";
import WhyWeBuiltThis from "../components/About/why-we-built-this";
import Positioning from "../components/About/positioning";
import Principles from "../components/About/principles";
import InfrastructureMap from "../components/Home/infrastructure-map";
import AboutCTA from "../components/About/cta";

function About() {
  return (
    <main>
      <div className="pt-20">
        <AboutHero />
        <WhyWeBuiltThis />
        <Positioning />
         <InfrastructureMap
          dark={true}
          tag="PRESENCE"
          title="Live in 40+ cities."
          description="Six hubs — Delhi NCR, Mumbai, Pune, Ahmedabad, Hyderabad, Bengaluru — feeding one routing layer."
          showRealTimeCard={false}
          showCityLabels={true}
          badgeText="Live in 40+ cities"
          badgeVariant="gold"
        />
        <Principles />
        <AboutCTA />
      </div>
    </main>
  );
}

export default About;
